export default __webpack_public_path__ + "static/media/Finland.e6682c3f.svg";